import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategorise } from '../../../../../mechanics/rid-categorise/rid-categorise';

@Component({
  selector: 'app-categorise-word-to-image-page',
  imports: [RidCategorise],
  templateUrl: './categorise-word-to-image-page.html',
})
export class CategoriseWordToImagePage {
  protected readonly $router = inject(Router);
}
